// src/components/Footer.js
import React from 'react';

function Footer() {
  return (
    <footer>
     <a>
        <p>© {new Date().getFullYear()} Himanshu Salary Corner. All rights reserved.</p>
      </a>
    </footer>
  );
}

export default Footer;
